export default __webpack_public_path__ + "static/media/tech_background_right.fbb9299a.png";